angular.module('app.directives', []).directive('scrollPage', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      return element.on('click', function(e) {
        var offset, scrollPage;
        e.preventDefault();
        offset = element.hasClass('nav-link-page') ? -50 : 0;
        scrollPage = new SmoothScroll();
        return scrollPage.animateScroll(document.querySelector($(this).attr('href')), 0, {
          updateURL: false,
          header: '.header-placeholder',
          offset: offset,
          speed: 200,
          speedAsDuration: true
        });
      });
    }
  };
}).directive('spw', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var observer, sentinel;
      // Why sentinel? Observing the sticky element directly doesn't work because
      // when stuck, it's still visible (intersecting). A sentinel before the element
      // lets us detect when scrolling reaches the stick point.
      sentinel = document.createElement('div');
      sentinel.style.height = '1px';
      sentinel.style.pointerEvents = 'none';
      sentinel.style.visibility = 'hidden';
      element[0].parentNode.insertBefore(sentinel, element[0]);
      observer = new IntersectionObserver(function(entries) {
        var isStuck;
        isStuck = !entries[0].isIntersecting;
        return element[0].toggleAttribute('stuck', isStuck);
      }, {
        threshold: [0, 1]
      });
      observer.observe(sentinel);
      return scope.$on('$destroy', function() {
        var ref;
        observer.disconnect();
        if (sentinel.parentNode) {
          return (ref = sentinel.parentNode) != null ? ref.removeChild(sentinel) : void 0;
        }
      });
    }
  };
}).directive('headroom', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var content, headroom;
      content = document.getElementById('page-content');
      headroom = new Headroom(element[0], {
        offset: content.offsetTop - 150,
        classes: {
          notTop: "person--not-top"
        }
      });
      return headroom.init();
    }
  };
}).directive('tooltip', [
  '$translate',
  function($translate) {
    return {
      restrict: 'A',
      link: function(scope,
  element,
  attrs) {
        return $translate(attrs.tooltipTitle).then(function(trs) {
          return bootstrap.Tooltip.getOrCreateInstance(element,
  {
            title: trs,
            trigger: 'hover'
          });
        });
      }
    };
  }
]).directive('scrollbar', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      return element.scrollbar();
    }
  };
}).directive('focusMe', function() {
  return {
    scope: {
      trigger: '=focusMe'
    },
    link: function(scope, element) {
      return scope.$watch('trigger', function(value) {
        if (value === true) {
          return element[0].focus();
        }
      });
    }
  };
//scope.trigger = false    
}).directive('scrollspy', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var scrollSpy;
      return scrollSpy = new bootstrap.ScrollSpy(document.body, {
        target: '#page-nav',
        offset: 115
      });
    }
  };
}).directive('countdown', function() {
  return {
    restrict: 'A',
    scope: {
      event_start: '=countdown'
    },
    link: function(scope, element, attrs) {
      var start;
      if (moment().isAfter(moment(scope.event_start))) {
        return document.getElementById('countdown-all').classList.add('d-none');
      } else {
        start = moment(scope.event_start).format('YYYY/MM/DD HH:mm:ss');
        return element.countdown(start, function(event) {
          $('#countdown-d').html(event.strftime('%D'));
          $('#countdown-h').html(event.strftime('%H'));
          $('#countdown-m').html(event.strftime('%M'));
          return $('#countdown-s').html(event.strftime('%S'));
        });
      }
    }
  };
}).directive('favcount', function() {
  return {
    restrict: 'A',
    scope: {
      count: '=favcount'
    },
    link: function(scope, element, attrs) {
      scope.$watch('count', function(newVal, oldVal) {
        return element[0].classList.add('animate');
      }, true);
      return element[0].addEventListener('animationend', function(event) {
        event.stopPropagation();
        return element[0].classList.remove('animate');
      });
    }
  };
}).directive('modalClose', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var $modal, modalId;
      modalId = element.closest('.modal').attr('id');
      $modal = $(`#${modalId}`);
      return element.on('click', function(e) {
        var $modalVideo;
        e.preventDefault();
        $modalVideo = $modal.find(".modal-video-src");
        $modalVideo.attr("src", '');
        $modal.modal('hide');
        return scope.$applyAsync();
      });
    }
  };
}).directive("compareTo", function() {
  return {
    require: "ngModel",
    scope: {
      confirmPassword: "=compareTo"
    },
    link: function(scope, element, attributes, modelVal) {
      modelVal.$validators.compareTo = function(val) {
        if (!val) {
          return true;
        }
        return val === scope.confirmPassword;
      };
      return scope.$watch("confirmPassword", function() {
        return modelVal.$validate();
      });
    }
  };
}).directive('fileModel', [
  '$parse',
  function($parse) {
    return {
      restrict: 'A',
      link: function(scope,
  element,
  attrs) {
        var model,
  modelSetter;
        model = $parse(attrs.fileModel);
        modelSetter = model.assign;
        return element.bind('change',
  function() {
          return scope.$apply(function() {
            return modelSetter(scope,
  element[0].files[0]);
          });
        });
      }
    };
  }
]).directive('onErrorSrc', function() {
  return {
    link: function(scope, element, attrs) {
      return element.bind('error', function() {
        if (attrs.src !== attrs.onErrorSrc) {
          return attrs.$set('src', attrs.onErrorSrc);
        }
      });
    }
  };
}).directive('myEnter', function() {
  return function(scope, element, attrs) {
    return element.bind("keydown keypress", function(event) {
      if (event.which === 13) {
        scope.$apply(function() {
          return scope.$eval(attrs.myEnter);
        });
        return event.preventDefault();
      }
    });
  };
}).directive('floatClose', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var $fv, fvID;
      fvID = element.closest('.fv').attr('id');
      $fv = $(`#${fvID}`);
      return element.on('click', function(e) {
        var $floatVideo, src;
        $floatVideo = $fv.find(".ritem");
        src = $floatVideo.attr("src");
        $floatVideo.attr("src", '');
        //$floatVideo.attr("src", src)
        return scope.$applyAsync();
      });
    }
  };
}).directive("validEmail", function() {
  return {
    require: "ngModel",
    scope: {
      email: "=validEmail"
    },
    link: function(scope, element, attributes, modelVal) {
      modelVal.$validators.validEmail = function(val) {
        if (!val) {
          return false;
        }
        return scope.email;
      };
      return scope.$watch("email", function() {
        return modelVal.$validate();
      });
    }
  };
}).directive('frvideo', [
  '$rootScope',
  function(root) {
    return {
      restrict: 'A',
      replace: true,
      scope: {
        frvideo: '=frvideo',
        frcid: '=frcid',
        freid: '=freid'
      },
      link: function(scope,
  element,
  attributes,
  modelVal) {
        var autoplay;
        scope.lang = root.lang;
        autoplay = attributes.autoplay ? 'autoplay="1"' : '';
        if (!scope.frcid) {
          scope.frcid = 1000;
        }
        if (!scope.freid) {
          scope.freid = 2000;
        }
        return element[0].innerHTML = "<b12-videoplayer ssp-device='VideoF_0' ssp-url='' uids='" + scope.frvideo + "' " + autoplay + " cid='" + scope.frcid + "' eid='" + scope.freid + "' elg='" + scope.lang + "'></b12-videoplayer>";
      }
    };
  }
]).directive('paginationFor', function() {
  return {
    restrict: 'A',
    template: '<nav ng-show="table.data.pages > 1"> <ul class="pagination jc-c gap-12 fw-wrap"> <li class="page-item" ng-class="{disabled: table.params.page == 1}"><a class="page-link" href rel="noffolow" ng-click="table.setPage(table.params.page - 1)"><svg class="fi fi-16 d-inline-block"><use xlink:href="assets/img/icons/feather-sprite.svg#chevron-left"/></svg></a></li> <li class="page-item" ng-repeat="page in table.pagination track by $index" ng-class="{active: table.params.page == page, disabled: !page}"> <a href rel="noffolow" class="page-link" ng-click="table.setPage(page)" ng-show="page">{{ page }}</a> <a href rel="noffolow" class="page-link" ng-hide="page">&hellip;</a> </li> <li class="page-item" ng-class="{disabled: table.params.page == table.data.pages}"><a class="page-link" href rel="noffolow" ng-click="table.setPage(table.params.page + 1)"><svg class="fi fi-16 d-inline-block"><use xlink:href="assets/img/icons/feather-sprite.svg#chevron-right"/></svg></a></li> </ul> </nav>',
    replace: true,
    scope: {
      table: '=paginationFor'
    },
    controller: ['$scope', '$filter', function(self, $filter) {}]
  };
}).directive('appointments', [
  '$window',
  '$rootScope',
  'APITimes',
  '$location',
  function($window,
  root,
  APITimes,
  $location) {
    return {
      restrict: 'A',
      template: '<div class="aus-footer" ng-show="isHasTimes()"> <div class="aus-time" ng-class="{\'active\': booked}"> <div ng-hide="booked">Make an appointment!</div> <div ng-show="booked"> <div class="opacity-50">Your appointment:</div> {{ booked.display_3 }} </div> <span class="ic" ng-class="{\'ic-add ic-add-check active\': booked}"><svg class="fi"><use xlink:href="assets/img/icons/feather-sprite.svg#calendar"/></svg></span> <a href rel="noffolow" class="stretched-link" ng-click="openTimeModal()"></a> </div> </div>',
      replace: true,
      scope: {
        exhibitor: '=appointments',
        random: '='
      },
      link: function(self,
  element,
  attrs) {
        var getData;
        self.times = [];
        getData = function() {
          var ref,
  ticket,
  times;
          //return unless root.user?.auth_ticket?
          ticket = ((ref = root.user) != null ? ref.auth_ticket : void 0) || 'tMzY1Ly8xNTMzOTcwLy8w'; //'tMzAxLy8xNDY1MjcyLy8w' <--- fallback ticket for test
          times = APITimes.query({
            _entry: 'times',
            exhibitor_id: self.exhibitor,
            auth_ticket: ticket
          },
  function(data) {
            self.times = angular.copy(times);
            self.booked = false;
            return self.booked = self.times.filter(function(item) {
              return item.booked;
            })[0] || false;
          });
        };
        self.isHasTimes = function() {
          var ref;
          return (((ref = root.user) != null ? ref.auth_ticket : void 0) != null) && self.times.length > 0;
        };
        self.openTimeModal = function() {
          return root.$broadcast('showTimeModal',
  self.times,
  'updateListTime');
        };
        self.$watch('random',
  function(oldObj,
  newObj) {
          return getData();
        },
  true);
      }
    };
  }
]).directive('datepicker', [
  '$cookies',
  '$rootScope',
  function($cookies,
  root) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        theme: '=',
        time: '='
      },
      link: function(self,
  element,
  attrs,
  ngModelCtrl) {
        var appTime;
        
        //timezone = root.setting('timezone') || 'Europe/Vienna'
        appTime = $cookies.get("app_time") || moment().format();
        return element.datetimepicker({
          dayOfWeekStart: 1,
          format: !!self.time ? 'H:i' : 'd/m/Y',
          lang: 'en',
          timepicker: !!self.time,
          datepicker: !!!self.time,
          closeOnDateSelect: true,
          mask: !!self.time ? '99:99' : '39/19/9999',
          theme: self.theme,
          onChangeDate: function(dp,
  $input) {
            return self.$apply(function() {
              return ngModelCtrl.$setViewValue(dp);
            });
          }
        });
      }
    };
  }
]).directive('datepickerr', [
  '$cookies',
  '$rootScope',
  function($cookies,
  root) {
    return {
      restrict: 'A',
      scope: {
        theme: '=',
        time: '='
      },
      link: function(self,
  element,
  attrs) {
        var getTime;
        getTime = function() {
          return $cookies.get("app_time") || moment().format('DD/MM/YYYY kk:mm');
        };
        return element.datetimepicker({
          dayOfWeekStart: 1,
          format: 'd/m/Y H:i',
          formatTime: 'H:i',
          formatDate: 'd/m/Y',
          lang: 'en',
          timepicker: !!self.time,
          datepicker: !!!self.time,
          closeOnDateSelect: false,
          theme: self.theme,
          todayButton: true,
          onChangeDateTime: function(dp,
  $input) {
            if (!dp) {
              return;
            }
            return self.$apply(function() {
              $cookies.put("app_time",
  moment(dp).format('DD/MM/YYYY kk:mm'));
              return root.$broadcast('fetchTime');
            });
          },
          onShow: function(ct) {
            var dt;
            dt = getTime();
            return this.setOptions({
              defaultDate: moment(dt,
  'DD/MM/YYYY kk:mm').format('DD/MM/YYYY'),
              defaultTime: moment(dt,
  'DD/MM/YYYY kk:mm').format('kk:mm')
            });
          }
        });
      }
    };
  }
]).directive('ytvideo', [
  '$rootScope',
  '$timeout',
  '$location',
  '$translate',
  function(root,
  $timeout,
  $location,
  $translate) {
    return {
      restrict: 'A',
      template: '<div id="ytPlayerWrap"> <div class="ratio ratio-16x9 mh-100"> <div class="video-next" ng-show="videoReady" ng-class="{\'video-next-full\': !video}"> <div ng-if="state != \'state\'" class="d-flex fd-column gap-5"> <div ng-show="before == 2 || before == 3" class="fw-n fs-2 lh-sm">{{ \'pages.program.text.continue_2\' | translate }}</div> <div class="h1 mb-0">{{ \'pages.program.text.p\' + before | translate }}</div> <div class="text-info fs-2 m-0">{{ state }}</div> </div> <div ng-if="state == \'state\'"> <div ng-if="!next && !video" class="d-flex fd-column gap-5"> <div class="h1 mb-0">{{ \'pages.program.text.p1\' | translate }}</div> <div class="fw-n fs-2 lh-sm">{{ \'pages.program.text.continue_1\' | translate }}</div> </div> <div ng-if="next && (!video || videoEnded)" class="d-flex fd-column gap-5"> <div class="fw-n fs-2 lh-sm">{{ \'pages.program.text.continue_2\' | translate }}</div> <div class="h1 mb-0">{{ lang == \'en\' ? next.title_en : next.title_de }}</div> <div class="text-info fs-2 m-0">{{ nes }}</div> </div> <div ng-if="!next && video && videoEnded" class="d-flex fd-column gap-5"> <div class="fw-n fs-2 lh-sm">{{ \'pages.program.soon\' | translate }}</div> </div> </div> </div> <div id="ytPlayer"></div> <div class="video-toggle-mute" ng-class="{\'video-toggle-off\': muted, \'video-toggle-on\': !muted, \'toggled\': toggled}" ng-click="toggleMute()"></div> <a href ng-click="toggleFull()" class="fullscreen" ng-show="video && !videoEnded"> <svg class="fi" ng-hide="fulls"><use xlink:href="assets/img/icons/siemens-sprite.svg#full-screen"/></svg> <svg class="fi" ng-show="fulls"><use xlink:href="assets/img/icons/siemens-sprite.svg#full-screen-exit"/></svg> </a> </div> </div>',
      replace: true,
      scope: {
        video: '=ytvideo',
        next: '=ytnext'
      },
      link: function(self,
  element,
  attrs) {
        var init;
        self.lang = root.lang;
        self.initDone = false;
        init = function() {
          var current,
  locParams,
  mmDate,
  playerVars,
  ref,
  ref1,
  ref2,
  ref3,
  start,
  trs;
          if (((ref = self.next) != null ? ref.id : void 0) < 0) {
            self.next = null;
            return;
          }
          trs = self.lang === 'en' ? 'january' : 'janvier';
          if (self.next != null) {
            self.nes = moment(`${self.next.dd} ${self.next.start}`,
  'YYYY-MM-DD HH:mm:ss');
            self.nes = self.nes.minutes() > 0 ? self.nes.format(`D [${trs}] YYYY, H[h]mm[m]`) : self.nes.format(`D [${trs}] YYYY, H[h]`);
          }
          self.videoReady = false;
          self.videoEnded = false;
          self.initDone = true;
          locParams = $location.search();
          mmDate = moment();
          if (locParams.time != null) {
            mmDate = moment(locParams.time,
  "hh:mm");
          }
          if (locParams.day) {
            mmDate = mmDate.date(parseInt(locParams.day) + 20);
          }
          self.state = "state";
          self.before = 1;
          if (mmDate.isBefore('2025-01-21 09:00:00')) {
            console.debug("state 1");
            self.before = 1;
            self.state = `21 ${trs} 2025, 9h`;
          } else if (mmDate.isBetween('2025-01-21 09:00:00',
  '2025-01-22 09:00:00') && !self.next) { // show next day program unless next and until next day start
            console.debug("state 2");
            self.before = 2;
            self.state = `22 ${trs} 2025, 9h`;
          } else if (mmDate.isBetween('2025-01-22 09:00:00',
  '2025-01-23 10:00:00') && !self.next) { // show next day program unless next and until next day start
            console.debug("state 3");
            self.before = 3;
            self.state = `23 ${trs} 2025, 10h`;
          }
          if (!((ref1 = self.video) != null ? ref1.slot_content.yt_id : void 0)) {
            console.debug("ready 1");
            self.videoReady = true;
            return (ref2 = self.player) != null ? ref2.destroy() : void 0;
          }
          locParams = $location.search();
          if (locParams.time != null) {
            current = moment(locParams.time,
  'HH:mm:ss');
          } else {
            current = moment(moment().format('HH:mm:ss'),
  'HH:mm:ss');
          }
          start = moment(self.video.start,
  'hh:mm:ss');
          start = moment.duration(current.diff(start)).as('seconds') || 0;
          console.debug("ins-",
  self.video.slot_content.yt_id);
          playerVars = {
            enablejsapi: 1,
            showinfo: 0,
            controls: 0,
            autoplay: 1,
            mute: 1,
            modestbranding: 0,
            disablekb: 1,
            rel: 0,
            playsinline: 1,
            origin: 'https://www.youtube.com'
          };
          if (((ref3 = self.video) != null ? ref3.slot_type : void 0) !== 'livestream') {
            playerVars.start = start;
          }
          return YT.ready(function() {
            return self.player = new YT.Player("ytPlayer",
  {
              videoId: self.video.slot_content.yt_id,
              playerVars: playerVars,
              events: {
                'onReady': function(event) {
                  console.debug("...video ready");
                  return self.videoReady = false;
                },
                'onStateChange': function(event) {
                  var ref4;
                  if (event.data >= 0) {
                    self.videoReady = true;
                    console.debug("ready 2");
                  }
                  console.debug("Data",
  event.data);
                  if (event.data === YT.PlayerState.ENDED) {
                    console.debug("---video ended",
  self.video,
  self.next);
                    self.videoEnded = true;
                    if ((ref4 = self.player) != null) {
                      ref4.destroy();
                    }
                    return self.$applyAsync();
                  } else if (event.data === YT.PlayerState.PLAYING) {
                    return console.debug("+++video playing");
                  } else if (event.data === YT.PlayerState.PAUSED) {
                    return console.debug("===video paused");
                  }
                }
              }
            });
          });
        };
        self.fulls = false;
        self.toggleFull = function() {
          var el;
          el = document.getElementById('ytPlayerWrap');
          if (!document.fullscreenElement) {
            el.requestFullscreen();
            return self.fulls = true;
          } else if (document.exitFullscreen) {
            document.exitFullscreen();
            return self.fulls = false;
          }
        };
        self.muted = true;
        self.toggleMute = function() {
          var ref;
          self.toggled = true;
          if (!((ref = self.player) != null ? ref.g : void 0)) {
            return;
          }
          if (self.player.isMuted()) {
            self.muted = false;
            return self.player.unMute();
          } else {
            self.muted = true;
            return self.player.mute();
          }
        };
        self.$watchGroup(['video.id',
  'next.id'],
  function(newObj,
  oldObj) {
          var ref;
          if ((ref = self.player) != null) {
            ref.destroy();
          }
          return init();
        },
  true);
      }
    };
  }
]).directive('fytvideo', [
  '$rootScope',
  '$timeout',
  '$location',
  '$translate',
  function(root,
  $timeout,
  $location,
  $translate) {
    return {
      restrict: 'A',
      template: '<div class="fp"> <div class="fp-controls"> <a href ng-click="toPrograms()"><svg class="fi"><use xlink:href="assets/img/icons/siemens-sprite.svg#link-extern"/></svg></a> <a href ng-click="toggleMute()"><svg class="fi" ng-show="muted"><use xlink:href="assets/img/icons/siemens-sprite.svg#volume-mute"/></svg><svg class="fi" ng-hide="muted"><use xlink:href="assets/img/icons/siemens-sprite.svg#volume-loud"/></svg></a> <a href ng-click="closePlayer()"><svg class="fi"><use xlink:href="assets/img/icons/siemens-sprite.svg#close"/></svg></a> </div> <div class="ratio ratio-16x9 fp-ratio"> <div id="ytFloatPlayer" class="fp-video"></div> <div class="fp-overlay text-white"></div> </div> </div>',
      replace: true,
      scope: {
        video: '=fytvideo'
      },
      link: function(self,
  element,
  attrs) {
        var init;
        init = function() {
          var current,
  playerVars,
  ref,
  ref1,
  ref2,
  start;
          self.videoReady = false;
          if (!((ref = self.video) != null ? ref.slot_content.yt_id : void 0)) {
            self.videoReady = true;
            element[0].classList.remove('fp-show');
            return (ref1 = self.player) != null ? ref1.destroy() : void 0;
          }
          self.videoEnded = false;
          current = moment(moment().format('HH:mm:ss'),
  'HH:mm:ss');
          start = moment(self.video.start,
  'hh:mm:ss');
          start = moment.duration(current.diff(start)).as('seconds') || 0;
          if (start < 0) {
            start = 0;
          }
          playerVars = {
            enablejsapi: 1,
            showinfo: 0,
            controls: 0,
            autoplay: 1,
            mute: 1,
            modestbranding: 0,
            disablekb: 1,
            rel: 0,
            playsinline: 1,
            origin: 'https://www.youtube.com'
          };
          if (((ref2 = self.video) != null ? ref2.slot_type : void 0) !== 'livestream') {
            playerVars.start = start;
          }
          return YT.ready(function() {
            return self.player = new YT.Player("ytFloatPlayer",
  {
              videoId: self.video.slot_content.yt_id,
              playerVars: playerVars,
              events: {
                'onReady': function(event) {
                  return self.videoReady = true;
                },
                'onStateChange': function(event) {
                  var ref3;
                  if (event.data === YT.PlayerState.ENDED) {
                    self.videoEnded = true;
                    element[0].classList.remove('fp-show');
                    if ((ref3 = self.player) != null) {
                      ref3.destroy();
                    }
                  } else if (event.data >= 0) {
                    element[0].classList.add('fp-show');
                  }
                  return self.$applyAsync();
                }
              }
            });
          });
        };
        self.toPrograms = function() {
          return $location.path("/program");
        };
        self.closePlayer = function() {
          return self.video = null;
        };
        self.muted = true;
        self.toggleMute = function() {
          var ref;
          self.toggled = true;
          if (!((ref = self.player) != null ? ref.g : void 0)) {
            return;
          }
          if (self.player.isMuted()) {
            self.muted = false;
            return self.player.unMute();
          } else {
            self.muted = true;
            return self.player.mute();
          }
        };
        self.$watch('video',
  function(newObj,
  oldObj) {
          return init();
        },
  true);
      }
    };
  }
]);
